var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashiconsPlusAlt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 194,
    viewBox: "0 0 194 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1219_4102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.8736 40.687C127.922 40.7354 153.012 65.8257 153.06 96.8737C153.05 111.772 147.127 126.058 136.592 136.593C126.058 147.127 111.772 153.05 96.8736 153.06C81.975 153.05 67.6896 147.127 57.1547 136.593C46.6198 126.058 40.697 111.772 40.6869 96.8737C40.7353 65.8257 65.8256 40.7354 96.8736 40.687ZM130.779 116.248L111.405 96.8737L130.779 77.4989L116.248 62.9679L96.8736 82.3426L77.4988 62.9679L62.9678 77.4989L82.3425 96.8737L62.9678 116.248L77.4988 130.779L96.8736 111.405L116.248 130.779L130.779 116.248Z",
    fill: "#3775C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1219_4102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 137,
    fill: "white",
    transform: "translate(0 96.8737) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashiconsPlusAlt);
export default __webpack_public_path__ + "static/media/dashicons-plus-alt.8b9b06d9627974f63b5490d00ef83bf0.svg";
export { ForwardRef as ReactComponent };